module.exports = __webpack_public_path__ + "static/media/p2p-platform.c3c40e18.svg";